import { render } from "./WorkerNew.vue?vue&type=template&id=4d797a64&scoped=true"
import script from "./WorkerNew.vue?vue&type=script&lang=js"
export * from "./WorkerNew.vue?vue&type=script&lang=js"

import "./WorkerNew.vue?vue&type=style&index=0&id=4d797a64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d797a64"]])

export default __exports__